$(document).ready(function(){

  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);



  // currency
  const currency = {AED:'&#1583;.&#1573;', AFN:'&#65;&#102;', ALL:'&#76;&#101;&#107;', AMD:'',ANG:'&#402;', AOA:'&#75;&#122;', ARS:'&#36;', AUD:'&#36;', AWG:'&#402;', AZN:'&#1084;&#1072;&#1085;', BAM:'&#75;&#77;', BBD:'&#36;', BDT:'&#2547;', BGN:'&#1083;&#1074;', BHD:'.&#1583;.&#1576;', BIF:'&#70;&#66;&#117;', BMD:'&#36;', BND:'&#36;', BOB:'&#36;&#98;', BRL:'&#82;&#36;', BSD:'&#36;', BTN:'&#78;&#117;&#46;', BWP:'&#80;', BYR:'&#112;&#46;', BZD:'&#66;&#90;&#36;', CAD:'&#36;', CDF:'&#70;&#67;', CHF:'&#67;&#72;&#70;', CLF:'',CLP:'&#36;', CNY:'&#165;', COP:'&#36;', CRC:'&#8353;', CUP:'&#8396;', CVE:'&#36;', CZK:'&#75;&#269;', DJF:'&#70;&#100;&#106;', DKK:'&#107;&#114;', DOP:'&#82;&#68;&#36;', DZD:'&#1583;&#1580;', EGP:'&#163;', ETB:'&#66;&#114;', EUR:'&#8364;', FJD:'&#36;', FKP:'&#163;', GBP:'&#163;', GEL:'&#4314;', GHS:'&#162;', GIP:'&#163;', GMD:'&#68;', GNF:'&#70;&#71;', GTQ:'&#81;', GYD:'&#36;', HKD:'&#36;', HNL:'&#76;', HRK:'&#107;&#110;', HTG:'&#71;', HUF:'&#70;&#116;', IDR:'&#82;&#112;', ILS:'&#8362;', INR:'&#8377;', IQD:'&#1593;.&#1583;', IRR:'&#65020;', ISK:'&#107;&#114;', JEP:'&#163;', JMD:'&#74;&#36;', JOD:'&#74;&#68;', JPY:'&#165;', KES:'&#75;&#83;&#104;', KGS:'&#1083;&#1074;', KHR:'&#6107;', KMF:'&#67;&#70;', KPW:'&#8361;', KRW:'&#8361;', KWD:'&#1583;.&#1603;', KYD:'&#36;', KZT:'&#1083;&#1074;', LAK:'&#8365;', LBP:'&#163;', LKR:'&#8360;', LRD:'&#36;', LSL:'&#76;', LTL:'&#76;&#116;', LVL:'&#76;&#115;', LYD:'&#1604;.&#1583;', MAD:'&#1583;.&#1605;.',MDL:'&#76;', MGA:'&#65;&#114;', MKD:'&#1076;&#1077;&#1085;', MMK:'&#75;', MNT:'&#8366;', MOP:'&#77;&#79;&#80;&#36;', MRO:'&#85;&#77;', MUR:'&#8360;', MVR:'.&#1923;', MWK:'&#77;&#75;', MXN:'&#36;', MYR:'&#82;&#77;', MZN:'&#77;&#84;', NAD:'&#36;', NGN:'&#8358;', NIO:'&#67;&#36;', NOK:'&#107;&#114;', NPR:'&#8360;', NZD:'&#36;', OMR:'&#65020;', PAB:'&#66;&#47;&#46;', PEN:'&#83;&#47;&#46;', PGK:'&#75;', PHP:'&#8369;', PKR:'&#8360;', PLN:'&#122;&#322;', PYG:'&#71;&#115;', QAR:'&#65020;', RON:'&#108;&#101;&#105;', RSD:'&#1044;&#1080;&#1085;&#46;', RUB:'&#1088;&#1091;&#1073;', RWF:'&#1585;.&#1587;', SAR:'&#65020;', SBD:'&#36;', SCR:'&#8360;', SDG:'&#163;', SEK:'&#107;&#114;', SGD:'&#36;', SHP:'&#163;', SLL:'&#76;&#101;', SOS:'&#83;', SRD:'&#36;', STD:'&#68;&#98;', SVC:'&#36;', SYP:'&#163;', SZL:'&#76;', THB:'&#3647;', TJS:'&#84;&#74;&#83;', TMT:'&#109;', TND:'&#1583;.&#1578;', TOP:'&#84;&#36;', TRY:'&#8356;', TTD:'&#36;', TWD:'&#78;&#84;&#36;', TZS:'',UAH:'&#8372;', UGX:'&#85;&#83;&#104;', USD:'&#36;', UYU:'&#36;&#85;', UZS:'&#1083;&#1074;', VEF:'&#66;&#115;', VND:'&#8363;', VUV:'&#86;&#84;', WST:'&#87;&#83;&#36;', XAF:'&#70;&#67;&#70;&#65;', XCD:'&#36;', XDR:'',XOF:'',XPF:'&#70;', YER:'&#65020;', ZAR:'&#82;', ZMK:'&#90;&#75;', ZWL:'&#90;&#36;'};
  if ( $('.main-carousel.most-popular').length >= 1 ) {
    var $currency_prod = $('.main-carousel.most-popular .product-info .price').data('currency');
    $('.main-carousel.most-popular .product-info .price > span, .block-new-arrivals .product-info .price > span').html(currency[$currency_prod]);
  }
  // THUMB ZOOM
  if ( $('.body-product-page').length >= 1 ) {
    $('[data-fancybox="images"]').fancybox({
      thumbs : {
        autoStart : true,
        axis      : 'x'
      }
    });
  }

  // video home
  function gcd(x, y){
    if (y == 0){ return x; }
    return gcd (y, x % y);
  }

  function videoHome() {

    var ratio = gcd($( window ).width(), $( window ).height());
    var testratio =  ($( window ).width()/ratio)/($( window ).height()/ratio);
    if(testratio>1.7777777){ //screen is wider than 16:9, do something
      $('#movie-lancio').removeClass('ratioHeight');
      $('#movie-lancio').addClass('ratioWidth');
    } else {
      $('#movie-lancio').removeClass('ratioWidth');
      $('#movie-lancio').addClass('ratioHeight');
    }

  }

  if ( $('#movie-lancio').length >= 1 ) {
    videoHome();
  }


  // ratio blocchi thumb-product
  function ratioProd() {
    if ( $('.lancio-hp').length >= 1 ) {
      var ratioProduct = gcd($('.lancio-hp .thumb-product').width(), $('.lancio-hp .thumb-product').height());
      var testratioProduct = ($('.lancio-hp .thumb-product').width()/ratioProduct)/($('.lancio-hp .thumb-product').height()/ratioProduct);
      // console.log(testratioProduct);

      var ratioContainerProduct = gcd($('.lancio-hp .col-lg-6').width(), $('.lancio-hp .col-lg-6').height());
      var testratioContainerProduct = ($('.lancio-hp .col-lg-6').width()/ratioContainerProduct)/($('.lancio-hp .col-lg-6').height()/ratioContainerProduct);
      // console.log(testratioContainerProduct);
      // console.log(Math.abs(testratioContainerProduct * 100));
      // console.log(testratioProduct-testratioContainerProduct);
      if ( testratioProduct >= 0.68458 ) {
        // $('.lancio-hp .thumb-product figure').css('width',''+ Math.abs(testratioContainerProduct * 140) + '%');
        var $hThumb = ( $('.lancio-hp.half-height').height() - 80 );
        $('.lancio-hp .thumb-product figure img').css('height',''+ $hThumb + 'px').addClass('width-auto');
      } else {
        $('.lancio-hp .thumb-product figure img').css('height','auto').removeClass('width-auto');
      }


    }
  }
  ratioProd();


  jQuery.event.special.scrolldelta = {
    // from http://learn.jquery.com/events/event-extensions/
    delegateType: "scroll",
    bindType: "scroll",
    handle: function (event) {
        var handleObj = event.handleObj;
        var targetData = jQuery.data(event.target);
        var ret = null;
        var elem = event.target;
        var isDoc = elem === document;
        var oldTop = targetData.top || 0;
        var oldLeft = targetData.left || 0;
        targetData.top = isDoc ? elem.documentElement.scrollTop + elem.body.scrollTop : elem.scrollTop;
        targetData.left = isDoc ? elem.documentElement.scrollLeft + elem.body.scrollLeft : elem.scrollLeft;
        event.scrollTopDelta = targetData.top - oldTop;
        event.scrollTop = targetData.top;
        event.scrollLeftDelta = targetData.left - oldLeft;
        event.scrollLeft = targetData.left;
        event.type = handleObj.origType;
        ret = handleObj.handler.apply(this, arguments);
        event.type = handleObj.type;
        return ret;
    }
  };


  //var mq = window.matchMedia("(min-width: 767px)");
  var mq = window.matchMedia("(min-width: 1023px)");
  var isMobile = !mq.matches;
  $('.bg-brands').css('background-image', 'url(img/bg_brand_White.jpg)');
  $('.list-brands a').bind('mouseover',function(event){
      var $bg_brand = $(this).data('bg');
      $(this).parents('.list-brands').addClass('hover');
      $(this).parents('.bg-brands').css('background-image', 'url(' + $bg_brand + ')');
  });
  $('.list-brands a').bind('mouseleave',function(event){
      $(this).parents('.list-brands').removeClass('hover');
      $(this).parents('.bg-brands').css('background-image', 'url(img/bg_brand_White.jpg)');
  });

  $('.js-carousel-boutique').flickity({
    wrapAround: true,
    contain: true,
    cellAlign: 'left',
  });

  // Accordion FAQ
  var allPanels = $('.accordion > dd').hide();
  $('.accordion > dt > a').click(function() {
    $('.accordion > dt').removeClass('active').find('span').removeClass('open');
    // $(this).parent('dt').next('dd').addClass('oooooo');
    if ( $(this).parent().next('dd').hasClass('open') ) {
      $(this).parent().next().slideUp().removeClass('open');
      $('.accordion dt a span').removeClass('open');
      $(this).parent('dt').removeClass('active');
    } else {
      allPanels.slideUp().removeClass('open');
      $(this).parent().next().slideDown().addClass('open');
      $(this).find('span').addClass('open');
      $(this).parent('dt').addClass('active');
    }
    return false;
  });

  // accordion product page
  $('.js-accordion').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    if ( $(this).hasClass('active') ) {
        $(this).removeClass('active').siblings('.content').removeClass('open');
    } else {
      $('.js-accordion').removeClass('active');
      $('.content').removeClass('open');
      $(this).addClass('active').siblings('.content').addClass('open');
    }
  });

  // btn wishlist
  $('.btn-wish').click(function(e) {
    $(this).toggleClass('active');
  });


  // btn buy mobile
  $('.js-btn-compra').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    $('.text-500.options-product').toggleClass('open');
    $('.overlay-btn-buy').addClass('open');
  });
  $('.overlay-btn-buy').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    $('.overlay-btn-buy').removeClass('open');
    $('.text-500.options-product').toggleClass('open');
  });
	
	//filter
  //$('.container-filters-order-by a, .container-filters-order-by button, .btn-filters').on('click', function(e){
  $("body").on("click", ".container-filters-order-by a:not(.not-filter), .container-filters-order-by button, .btn-filters", function(e){
    e.preventDefault();
    console.log("click filter 2");
    if ( $(this).parents('.filter').hasClass('open') ){
      console.log("2");
      $(this).parents('.filter').removeClass('open');
    } else {
      console.log("3");
      $('.container-filters-order-by .filter').removeClass('open');
      $(this).parents('.filter').addClass('open');
    }
  });
	
	// home click shop by style
	$('.layout-shop-link .carousel-cell > a').click(function(e) {
    console.log("riga 172");
    e.preventDefault();
    e.stopPropagation();

    var $currency_prod = $('.main-carousel.most-popular .product-info .price').data('currency');
    $('.js-products-mobile.carousel-product .product-info .price > span').html(currency[$currency_prod]);

    var sec = $(this).data('section');
    $('.layout-shop-link .carousel-cell').addClass('bg-color-page-dark');
    $(this).parents('.carousel-cell').removeClass('bg-color-page-dark');
    $('.layout-shop-link-sub, .carousel-shop > .carousel-product, .carousel-shop > .row').removeClass('active');
    $('#p-'+sec+'').addClass('active');
    $('#marquee-'+sec+'').addClass('active');
		if( sec == "category" ){
			if (isMobile) {
				$carouselMobile.flickity('destroy');
				$carouselMobile.flickity({
					// options
					wrapAround: true,
					contain: true,
					prevNextButtons: false,
					pageDots: false,
					cellAlign: "left",
					//autoPlay: 3000,
					pauseAutoPlayOnHover: false
				});
			}
			$carouselShopDesk.flickity({
				// options
				wrapAround: true,
				pageDots: false,
				cellAlign: "left",
				contain: true
			});
			$('.section-shop-category .marquee').removeClass('show');
			var $catSelected = $('.js-carousel-shop-link-desk .carousel-cell.is-selected').text().replace(" ", "");
			$('.section-shop-category .marquee-'+$catSelected+'').addClass('show');
			
			// marquee iniziale
			if ( !$('.section-shop-category .marquee').eq(0).find('.js-marquee-wrapper').length >= 1 ) {
				jQuery('.section-shop-category .marquee').eq(0).marquee({
					duration: 15000,
					//gap in pixels between the tickers
					gap: 0,
					//time in milliseconds before the marquee will start animating
					delayBeforeStart: 0,
					//'left' or 'right'
					direction: 'left',
					//true or false - should the marquee be duplicated to show an effect of continues flow
					duplicated: true
				});
			}
			
      function clickSubCategory(){
        // pulisco tutti i campi
				$('#p-category .carousel-cell a').attr('href','');
				$('#p-category .carousel-cell img').attr('src','/themes/1358/Vietti_BT4/images/img/t.png');
				$('#p-category .carousel-cell .brand').text('');
				$('#p-category .carousel-cell .price').text('');

				var $carouselActive = jQuery('#marquee-category .js-carousel-shop-link-desk .is-selected');

				var $url = $carouselActive.data('url');
				var $urlCat = $carouselActive.data('urlcat');
				var $image = $carouselActive.data('image');
				var $brand = $carouselActive.data('brand');
				var $price = $carouselActive.data('price');
        $currency_prod = $('.main-carousel.most-popular .product-info .price').data('currency');
        //var $currency_prod = $carouselActive.data('currency');
        //var $currency_prod = $('.js-carousel-loop-popular .carousel-cell.is-selected .product-info .price > span').text();

				var $url = $url.split(',');
				for (var a in $url)
				{
					var $variable = $url[a];
					$('#p-category .carousel-cell:eq('+a+') a').attr('href',$variable);
				}

				var $image = $image.split(',');
				for (var a in $image)
				{
					var $variable = $image[a];
					if ( $variable == '' ) {
						$('#p-category .carousel-cell:eq('+a+') img').attr('src','/themes/1358/Vietti_BT4/images/img/t.png');
					} else {
						$('#p-category .carousel-cell:eq('+a+') img').attr('src',$variable);
					}
				}

				var $brand = $brand.split(',');
				for (var a in $brand)
				{
					var $variable = $brand[a];
					$('#p-category .carousel-cell:eq('+a+') .brand').text($variable);
				}

				var $price = $price.split(',');
				for (var a in $price)
				{
					var $variable = $price[a];
          if ( $variable ) {
            console.log("1");
					  $('#p-category .carousel-cell:eq('+a+') .price').html(currency[$currency_prod]+' '+$variable);
          }
				}
      }
			$('.js-carousel-shop-link-desk .flickity-prev-next-button').click(function(e) {
				console.log("click")
        clickSubCategory();
			});
			
      $('.js-carousel-shop-link-desk').on( 'change.flickity', function( event, index ) {
        console.log("swipe")
        clickSubCategory();
      });

			$carouselShopDesk.on( 'change.flickity', function( event, index ) {
				var $catSelected = $('.js-carousel-shop-link-desk .carousel-cell.is-selected').text().replace(" ", "");
				$('.section-shop-category .marquee').removeClass('show');
				$('.section-shop-category .marquee-'+$catSelected+'').addClass('show');
				//console.log( 'Slide changed to ' + index );
				if ( !$('.marquee-'+$catSelected+' .js-marquee-wrapper').length >= 1 ) {
					jQuery('.marquee-'+$catSelected+'').marquee({
						duration: 15000,
						//gap in pixels between the tickers
						gap: 0,
						//time in milliseconds before the marquee will start animating
						delayBeforeStart: 0,
						//'left' or 'right'
						direction: 'left',
						//true or false - should the marquee be duplicated to show an effect of continues flow
						duplicated: true
					});
				}
			});
			setTimeout(function(){
				var $urlC = jQuery('#marquee-category .js-carousel-shop-link-desk .is-selected a.link-section').data('urlcat');
				$('#p-category a.js-btn-more-products, .js-link-product-all').attr('href',$urlC);
			}, 1000);
			
		}
		if( sec == "designer" ){
			if (isMobile) {
				$carouselMobile.flickity('destroy');
				$carouselMobile.flickity({
					// options
					wrapAround: true,
					contain: true,
					prevNextButtons: false,
					pageDots: false,
					cellAlign: "left",
					//autoPlay: 3000,
					pauseAutoPlayOnHover: false
				});
			}
			$('.js-carousel-marquee').flickity({
				// options
				autoPlay: 1500,
				wrapAround: true,
				pageDots: false,
				prevNextButtons: true,
				draggable: false
			});
			$('.js-carousel-marquee .carousel-cell').on('click', function() {
				$('.js-carousel-marquee .carousel-cell').removeClass('active');
				$(this).addClass('active');
        $('.js-carousel-marquee').flickity('playPlayer');
    	});
			var $urlC = $(this).data('urlcat');
			//$('#p-designer a.js-btn-more-products').attr('href',$urlC);
			if ( !$('.marquee-designer .js-marquee-wrapper').length >= 1 ) {
				jQuery('.marquee-designer').marquee({
					duration: 15000,
					//gap in pixels between the tickers
					gap: 0,
					//time in milliseconds before the marquee will start animating
					delayBeforeStart: 0,
					//'left' or 'right'
					direction: 'left',
					//true or false - should the marquee be duplicated to show an effect of continues flow
					duplicated: true
				});
			}
		}
  });

  // home section shop by
  $('.js-link-marquee').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
		$('.js-link-marquee').removeClass('active');
		$(this).addClass('active');
    var $el = $(this).data('link');
		$('.div-style').removeClass('active');
    $('#div-'+$el+'').addClass('active');
  });

  if ( $('.js-carousel-article-news').length >= 1 ) {
    var $pIndex = 0;
    var sPageURL = window.location.search.substring(1);
    var sPageURL = sPageURL.split('=');
    if ( sPageURL != undefined ) {
      $pIndex = sPageURL[1];
    } 
    $('.js-carousel-article-news').flickity({
      // options
      wrapAround: true,
      pageDots: false,
      cellAlign: "left",
      contain: true,
      prevNextButtons: true,
      initialIndex: $pIndex 
    });
  }
  

	//setTimeout(function(){
  $('.js-carousel-sizess').flickity({
    // options
    wrapAround: true,
    pageDots: false,
    cellAlign: "left",
    contain: true,
    prevNextButtons: true,
  });
	//}, 5000);

  $('.js-carousel-box-home').flickity({
    // options
    wrapAround: true,
    pageDots: false,
    cellAlign: "center",
    contain: true,
    prevNextButtons: true,
  });
	/*
    $('.js-carousel-loop-popular').flickity({
      wrapAround: true,
      pageDots: false,
      cellAlign: "left",
      contain: true,
      prevNextButtons: true,
      pauseAutoPlayOnHover: true,
      //selectedAttraction: 0.01,
      //friction: 0.15
    });
	*/

  $('.js-carousel-loop-popular').owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      dots:false,
      responsive:{
          0:{
              items:2
          },
          768:{
              items:3
          },
          1000:{
              items:5
          }
      }
  });

  /*
  $('.js-carousel-brands').flickity({
    wrapAround: true,
    pageDots: false,
    cellAlign: "left",
    contain: true,
    prevNextButtons: true,
    pauseAutoPlayOnHover: true,
    //selectedAttraction: 0.01,
    //friction: 0.15
  });
  */
  $('.js-carousel-brands').owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      dots:false,
      responsive:{
          0:{
              items:1
          },
          768:{
              items:4
          },
          1000:{
              items:4
          }
      }
  });
  
  $('.js-carousel-product-single-page').flickity({
    // options
    wrapAround: true,
    pageDots: true,
    cellAlign: "left",
    contain: true,
    prevNextButtons: true,
  });
  

  $('.js-carousel-post').flickity({
    // options
    wrapAround: true,
    pageDots: true,
    cellAlign: "left",
    contain: true,
    prevNextButtons: true,
  });
 

  //var $carouselHomeMobile = $('.js-carousel-home');
  var $carouselHome = $('.js-main-carousel-home');
  var $carouselMobileHp = $('.js-products-mobile');
  var $carousel = $('.js-carousel-product');
  var $carouselLoop = $('.js-carousel-loop');
  var $carouselPageMobile = $('.js-product-page-mobile');
  var $carouselShop = $('.js-carousel-shop-link');
	var $carouselShopDesk = $('.js-carousel-shop-link-desk');
  if (isMobile) {
    /*
    $carouselHome.flickity({
      wrapAround: true,
      pageDots: true,
      cellAlign: "left",
      contain: true,
      prevNextButtons: false,
    });
    */
    $carouselHome.owlCarousel({
        loop:true,
        margin:0,
        nav:false,
        items:1,
        dots:true
    });
    //$('.js-products-mobile').owlCarousel({
    $carouselMobileHp.owlCarousel({
        loop:true,
        margin:0,
        nav:false,
        items:2,
        dots:false
    });
    $carouselLoop.flickity({
      wrapAround: true,
      pageDots: false,
      cellAlign: "left",
      contain: true,
      prevNextButtons: false,
    });
    /*
    $carouselHomeMobile.flickity({
      // options
      wrapAround: true,
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      cellAlign: "left",
      autoPlay: 3000,
      pauseAutoPlayOnHover: false
    });  
      
    $carouselMobile.flickity({
      // options
      wrapAround: true,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      cellAlign: "left",
      pauseAutoPlayOnHover: false
    });
    /*
    $carouselMobile.owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      dots:false,
      responsive:{
          0:{
              items:2
          },
          768:{
              items:3
          },
          1000:{
              items:5
          }
      }
    });
    
    $carouselPageMobile.flickity({
      // options
      wrapAround: true,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      cellAlign: "left",
      pauseAutoPlayOnHover: false
    });
    */
    $carouselPageMobile.owlCarousel({
        loop:true,
        margin:0,
        nav:false,
        items:2,
        dots:false
    });
    $carouselShop.flickity({
      // options
    });
		
    //$carousel.flickity({
      // options
      //prevNextButtons: false
    //});
		
		// product page
		if ( $('.product-images').length >= 1 ) {
			$('.product-images .carousel-vertical a').data('fancybox','images');
		}

    // footer menu
    jQuery('#site_footer .footer-links label.button').click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      jQuery(this).toggleClass('open').next('.content').toggleClass('open');
      //var $urlWindowLocation = jQuery(this).next('.content').find('a').eq(0).attr('href');
      //window.location.href = $urlWindowLocation;

    });

    $('aside .js-carousel-shop-link .flickity-prev-next-button').click(function(e) {
      console.log("click");
      jQuery('aside .js-carousel-shop-link .carousel-cell.is-selected a').trigger( "click" );
    });
    
    $('aside .js-carousel-shop-link').on( 'change.flickity', function( event, index ) {
      console.log("swipe menu myaccount: "+index+" prova");
      $('.static-page-nav.desktop-only.nav li').eq(index).find('a').trigger( "click" );
      //$('aside .js-carousel-shop-link .carousel-cell.is-selected a').trigger( "click" );
    });

  } else { // desktop
		
    //$carouselHomeMobile.flickity('destroy');
    $('.js-carousel-loop').flickity({
      wrapAround: true,
      pageDots: false,
      cellAlign: "center",
      contain: true,
      prevNextButtons: false,
      autoPlay: 3000,
      pauseAutoPlayOnHover: false
    });
		
    var $indexFancybox = 0;
    $('.product-images .carousel-vertical a').click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      var $productPic = $(this).attr('href');
      $indexFancybox = $(this).data('index');
      $('.product-image-single a.js-image').attr('href',$productPic);
      $('.product-image-single a.js-image img').attr('src',$productPic);
    });
    $('.product-image-single a').click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      //get the group of your fancy elements
      var fancygroup = $("a[rel=example_group]");
      // get the element you want to focus (e.g the first element)
      var fancyelem = $(fancygroup.get($indexFancybox));
      // simulate a click
      fancyelem.click();
    });
    if ( $('.product-data').length >= 1 ) {
      $('.product-data > ul > li:first-child .content').addClass('open');
    }

    // single news page
    if ( $('.js-carousel-article-news').length >= 1 ) {
      var $hCarousel = $('.js-carousel-article-news').height();
      $hCarousel = $hCarousel - 180;
      //$('.caption-news').height($hCarousel);
    }


    // filters sticky
    var offset = 0;
  	var sticky = false;
  	var startPage = $('html,body').scrollTop();
    var scroll = "";

    if ( $('.element-sticky').length >= 1 ) {
      var winProp = $(".element-sticky").innerHeight() - (window.innerHeight - 46);
      var pp = $(".element-sticky").offset().top;
      var pp2 = $(".element-sticky").innerHeight();
    }

    var position = $(window).scrollTop();
    if ( $('.container-filters-order-by').length >= 1 ) {
      var topFilter = $(".container-filters-order-by").offset().top;
      // console.log(topFilter);
    }
    // scroll della pagina comportamento
    $( window ).scroll(function() {
      startPage = $('html,body').scrollTop();
      scroll = pp+startPage;
      //scroll = pp+pp+startPage;
      // header slide up da togliere
			if ( $('.container-filters-order-by').length >= 1 ) {
        if ( (topFilter - 45) <= startPage) {
          var scroll = $(window).scrollTop();
					if(scroll > position) {
            // scrollDown
            //$('header > ul > li:nth-child(2)').addClass('slide-up');
            $(".container-filters-order-by, .btn-delete-all-filters").addClass("sticky");
            $(".container-filters-order-by").addClass("border-left-black");
            $(".container-filters-order-by").addClass("border-bottom-black");
          	sticky = true;
          } else {
            // scrollUp
						if ( scroll <= 45 ) {
							//$('header > ul > li:nth-child(2)').removeClass('slide-up');
							$(".container-filters-order-by, .btn-delete-all-filters").removeClass("sticky");
              $(".container-filters-order-by").removeClass("border-left-black");
              $(".container-filters-order-by").removeClass("border-bottom-black");
							sticky = false;
						}
          }
          position = scroll;
        } else {
          //$('header > ul > li:nth-child(2)').removeClass('slide-up');
          $(".container-filters-order-by, .btn-delete-all-filters").removeClass("sticky");
          sticky = false;
        }
      } else {
        if ( startPage >= 45 ) {
          var scroll = $(window).scrollTop();
          if(scroll > position) {
            // scrollDown
            //$('header > ul > li:nth-child(2)').addClass('slide-up');
          } else {
            // scrollUp
            //$('header > ul > li:nth-child(2)').removeClass('slide-up');
          }
          position = scroll;
        } else {
          //$('header > ul > li:nth-child(2)').removeClass('slide-up');
        }
      }


      // page catalogue
    	// if ($(".layout-desktop").offset().top < startPage) {
    	// 	$(".layout-box.box-filters").addClass("sticky");
    	// 	sticky = true;
    	// } else {
    	// 	$(".layout-box.box-filters").removeClass("sticky");
      //   sticky = false;
    	// }

      // page product
      // if ( $(window).width() >= 1080 && $('.element-sticky').length >= 1 ) {
      //   if ($(".layout-desktop").offset().top < startPage && startPage < $(".layout-desktop").offset().top + 10) {
      //     $(".element-sticky, .product-images").addClass("sticky");
      //     sticky = true;
      //   }
      //
      //   if (startPage + (window.innerHeight - 46) >= $('#stop-sticky').offset().top - 46) {
      //     $(".element-sticky, .product-images").addClass("sticky-bottom");
      //     sticky = false;
      //   }
      //   if (startPage + (window.innerHeight - 46) <= $('#stop-sticky').offset().top - 46) {
      //     $(".element-sticky").removeClass("sticky-bottom");
      //   }
      //
      //
      //   if ( $(".layout-desktop").offset().top > startPage ) {
      //     $(".element-sticky, .product-images").removeClass("sticky");
      //     sticky = false;
      //   }
      // }


      // close filter
      $('.overlay-filter, .btn-filters > span').removeClass('open');

    });


    // click close overaly
    $('main.layout-desktop').click(function(e) {
      var $target = $(e.target);
      var menuOverlay = $("nav.nav");
      var filterOverlay = $('.overlay-filter');
      var searchOveraly = $('.layout-search');
      var minicartOveraly = $('.aside-cart');
      var loginOveraly = $('.aside-login');
      var btnBuyMobile = $('.text-500.options-product');
      //$('body').toggleClass('no-scroll');
			if ($("body").hasClass("no-scroll")) {
				$('body').removeClass('no-scroll');
			}
      if (!$target.is(btnBuyMobile) && !$target.is($('.js-btn-compra'))) {
          if (menuOverlay.is(':visible')) {
            menuOverlay.removeClass('open');
            btnBuyMobile.removeClass('open');
						$('body').removeClass('no-scroll');
          }
      }
      if (!$target.is(menuOverlay) && !$target.is($('.btn-ico-menu'))) {
          if (menuOverlay.is(':visible')) {
            menuOverlay.removeClass('open');
            $('.js-navbar-toggler').removeClass('open');
						$('body').removeClass('no-scroll');
          }
      }
      if (!$target.is(filterOverlay) && !$target.is($('.btn-filters'))) {
          if (filterOverlay.is(':visible')) {
            filterOverlay.removeClass('open');
            $('.btn-filters > span').removeClass('open');
            $('.js-navbar-toggler').removeClass('open');
						$('body').removeClass('no-scroll');
          }
      }
      if (!$target.is(searchOveraly) && !$target.is($('.btn-ico-search'))) {
          if (searchOveraly.is(':visible')) {
            searchOveraly.removeClass('open');
            $('.js-navbar-toggler').removeClass('open');
						$('body').removeClass('no-scroll');
          }
      }
      if (!$target.is(minicartOveraly) && !$target.is($('.btn-ico-cart'))) {
          if (minicartOveraly.is(':visible')) {
            minicartOveraly.removeClass('open');
            $('.js-navbar-toggler').removeClass('open');
						$('body').removeClass('no-scroll');
          }
      }
      if (!$target.is(loginOveraly) && !$target.is($('.btn-ico-cart'))) {
          if (loginOveraly.is(':visible')) {
            loginOveraly.removeClass('open');
            $('.js-navbar-toggler').removeClass('open');
						$('body').removeClass('no-scroll');
          }
      }
    });

  }

	setTimeout(function(){
		$('.js-products-carousel').flickity({
			// options
			contain: false,
			prevNextButtons: true,
			pageDots: false,
			cellAlign: 'left',
			wrapAround: true,
      on: {
        ready: function() {
          $('.js-products-carousel').addClass('show');
        },
        change: function( index ) {
          console.log( 'Slide changed to' + index );
        }
      }
		});
	}, 5000);

  
  // menu
  var $posMenuGender = true;
  $('.js-navbar-toggler').on('click', function(e){
    e.preventDefault();
    $('#searchElasticContainer').addClass('closed');
    $(this).toggleClass('open');
    $('body').toggleClass('no-scroll');
    $('aside.aside-cart, aside.aside-login, .filters, .layout-search').removeClass('open');
    // if (isMobile) {
    //   $('body').toggleClass('no-scroll');
    // }
    var $hPage = $('body').height();
    var $hHeader = $('header').height();
    $hPage = $hPage - ($hHeader*2);
    //$('nav.nav').height($hPage);
    $('nav.nav').toggleClass('open');
    $posMenuGender = true;
    $('.box-nav-wrapper').css('left','0px');
    $(this).parents('.nav-generic.open').css('right','-100%');
    $('.nav-primary li, .nav-generic li').removeClass('active');
  });
  $('.js-btn-nav-menu').on('click', function(e){
    e.preventDefault();
    var $gender = $(this).data('link');
    var $wMenu = $('nav.nav').width();
		var $wMenu = $wMenu-1;
		$('.box-nav-wrapper > .box-menu > .menu-hidden').removeClass('open');
    $('.menu-'+$gender+'').addClass('open');
    $('.box-nav-wrapper').css('left','-'+$wMenu+'px');
    $('.nav-primary li').removeClass('active');
    $(this).parents('li').addClass('active');
  });
  $('.nav-primary li a, .nav-generic li a').bind('mouseover',function(event){
      $(this).parents('li').addClass('active');
  });
  $('.nav-primary li a, .nav-generic li a').bind('mouseleave',function(event){
      $(this).parents('li').removeClass('active');
  });
  $('.js-btn-sub-menu').on('click', function(e){
    e.preventDefault();
    if ( $(this).parent('li').find('ul.nav-generic li').length >= 3 ) {
      $(this).parents('li').addClass('active');
      $posMenuGender = false;
      //console.log($posMenuGender);
      $(this).next('.nav-generic').css('right','0%').addClass('open');
    } else {
      var $urlWindowLocation = jQuery(this).attr('href');
      window.location.href = $urlWindowLocation;
    }
  });
  $('.js-btn-back-menu').on('click', function(e){
    e.preventDefault();
    $('.nav-generic li').removeClass('active');
    if ( $posMenuGender == true ){
      $('.box-nav-wrapper').css('left','0px');
      $('.nav-primary li').removeClass('active');
    } else {
      $(this).parents('.nav-generic.open').css('right','-100%');
      $posMenuGender = true;
    }
  });


  // btn cart aside
  $('.js-btn-cart').on('click', function(e){
    e.preventDefault();
    $('.filters, .layout-search, nav.nav').removeClass('open');
    $('aside.aside-login, .js-navbar-toggler').removeClass('open');
    $('aside.aside-cart').toggleClass('open');
    $('body').toggleClass('no-scroll');
  });

  // btn login aside
  $('.js-btn-login').on('click', function(e){
    e.preventDefault();
    $('.filters, .layout-search, nav.nav').removeClass('open');
    $('aside.aside-cart, .js-navbar-toggler').removeClass('open');
    $('aside.aside-login').toggleClass('open');
    $('body').toggleClass('no-scroll');
  });

  // btn filters mobile
  $("body").on("click", ".js-delete-all-filters", function(e){
    e.preventDefault();
    //var sPageURL = window.location.search.substring(1);
    var sPageURL = $(location).attr('href')
    var sPageURL = sPageURL.split('?');
    window.location.href = sPageURL[0];
  });

  //$('.js-btn-filters').on('click', function(e){
  $("body").on("click", ".js-btn-filters", function(e){
    e.preventDefault($('.filters'));
    $('aside.aside-cart, aside.aside-login, .layout-search, nav.nav, .js-navbar-toggler').removeClass('open');
    $('.filters, .container-order-by').toggleClass('open');
    $(this).find('span').toggleClass('open');
  });
  $('.js-btn-close-filters, .js-btn-filter-apply').on('click', function(e){
    e.preventDefault();
    $('aside.aside-cart, aside.aside-login, .layout-search, nav.nav, .js-navbar-toggler').removeClass('open');
    $('.filters').removeClass('open');
    $(this).find('span').removeClass('open');
  });
	
	$('.container-filters-order-by a:not(.not-filter), .container-filters-order-by button, .btn-filters').on('click', function(e){
		e.preventDefault();
		$(this).next('.overlay-filter').toggleClass('open');
		$(this).toggleClass('open');
    console.log("click riga 839");
	});
  $("body").on("click", ".content-filter a.text-truncate", function(e){
    console.log("click riga 845");
    e.preventDefault();
    $thisFilter = $(this).data('filter');
    $idFilter = $(this).parents('.filter').attr('id');
    $numSel = $('#'+$idFilter+' a.text-truncate.active').length;
    //console.log($numSel);
    //console.log($thisFilter);
    if ( $numSel == 0 ) {
      $(this).parents('.filter').find('.btn-filters').removeClass('selected');
      $(this).parents('.filter').find('.btn-filters .countFilter').removeClass('active').text('');
      $('.js-delete-all-filters').addClass('hide');
    } else {
      $(this).parents('.filter').find('.btn-filters').addClass('selected');
      $(this).parents('.filter').find('.btn-filters .countFilter').addClass('active').text($numSel);
      $('.js-delete-all-filters').removeClass('hide');
    }
    /*
    if ( $numSel >= 2 || $numSel == 0 ) {
      $(this).parents('.filter').find('.btn-filters').addClass('selected');  
    } else if ( $numSel == 1 ) {
      $('#'+$idFilter+' a.text-truncate.active').each(function( index ) {
        var $id = $(this).data('filter');
        console.log( $id + " - " + $thisFilter );
        if ( $id == $thisFilter ) {
          $(this).parents('.filter').find('.btn-filters').removeClass('selected');
        } else {
          $(this).parents('.filter').find('.btn-filters').addClass('selected');
        }
      });
    }
    */
    //$(this).parents('.filter').find('.btn-filters').addClass('selected');
  });
  $("body").on("click", ".content-filter a.text-capitalize", function(e){
    console.log("click riga 850");
    e.preventDefault();
    $(this).parents('.filter').find('.btn-filters').removeClass('selected');
    $(this).parents('.filter').find('.btn-filters .countFilter').removeClass('active').text('');
  });
	
	
	// btn menu about
	$('.js-btn-menu-about').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
		$('.sub-menu').removeClass('open');
		$(this).next('.sub-menu').addClass('open');
	});
	
	// btn menu about mobile
	$('.js-link-section').click(function(e) {
		console.log("ddddd");
    e.preventDefault();
    e.stopPropagation();
		var $subMenu= $(this).data('section');
		$('.sub-menu-list').removeClass('open');
		$('#'+$subMenu+'').addClass('open');
	});
	

  // btn search
  $('.js-search-toggler').on('click', function(e){
    e.preventDefault();
    $('aside.aside-cart, aside.aside-login, .layout-search, nav.nav, .js-navbar-toggler').removeClass('open');
    //$('aside.aside-cart, aside.aside-login, .filters, nav.nav').removeClass('open');
    $('.layout-search').toggleClass('open');
    $('body').toggleClass('no-scroll');
    $('.form-search input[type="text"]').focus();
  });

  // image absolute
  if ( $('.image-absolute').length >= 1 ) {
    $( ".image-absolute" ).each(function( index ) {
      var $img = $(this).find('img').attr('src');
      $(this).css('background-image', 'url(' + $img + ')');
    });
  }

  // Multiple slider
  if ( $('.multiple-loader-slider').length >= 1 ) {
    var $img = $('.multiple-loader-slider').find('img').attr('src');
    var $link = $('.multiple-loader-slider').find('img').data('link');
    $('.multiple-loader-slider').css('background-image', 'url(' + $img + ')');
    $('.multiple-link-slider').attr("href", ''+$link+'');
    $('.loader span').addClass('start');

    var obj = [];
    $( ".multiple-loader-slider img" ).each(function( index ) {
      obj.push({
            img: $(this).attr('src'), 
            link: $(this).data('link')
      });
    });

    var listItems = obj.length;
    var count = 0;
    var totLoop = 6000*listItems;
    setInterval(function() {
        count += 1;
        var offset = 1;
        $.each( obj, function( key, value ) {
          $('.multiple-loader-slider').css('background-image', 'url(' + value.img + ')');
          $('.multiple-link-slider').attr("href", ''+value.link+'');
          setTimeout(function(){
            $('.loader span').addClass('start');
            $('.multiple-loader-slider').css('background-image', 'url(' + value.img + ')');
            $('.multiple-link-slider').attr("href", ''+value.link+'');
          }, 6000 + offset);
          offset += 6000;
        });
        if (count >= listItems) {
            count = 0;
        }
    }, totLoop);

  }

  // size mobile
  $('select.js-btn-size-mobile').on('change', function() {
    // alert( this.value );
    $('.btn-size-mobile-value').text( this.value );
  });


  // Accordion
  $('.js-accordion').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    $(this).siblings('.container-accordion-box').toggleClass('open');
  });


  // news page
  /*
  if ( $('.list-news').length >= 1 ){
    $('.list-news').masonry({
      // options
      itemSelector: 'article'
    });
  }
  */

  function heightStaticContent() {
    if( $('.static-page-content').length >= 1 ) {
      var $hStaticComtent = $('.static-page-content').height();
      if ( $hStaticComtent >= $(window).height() ) {
        $('.static-page-content > .row').addClass('noBottomBorder');
      }
    }
  }
  heightStaticContent();

  function heightPagProduct() {
    if ( $(window).width() >= 1075 && $('.product-image-single').length >= 1 ) {
      var $heightImg = $('.product .row .product-image-single figure').height();
      var $heightData = $('.product .row .product-data').height();
      if ( $heightImg < $heightData ) {
        $('.product .row .product-image-single').css('height',$heightData);
        //$('.product .row .product-images').css('paddingTop',$heightData);
      } else {
        $('.product .row .product-image-single').css('height','auto');
        //$('.product .row .product-images').css('paddingTop',$heightData);
      }
    }
  }
  heightPagProduct();
  // var isFlickity = true;
  // // toggle Flickity on/off
  // $('.button--toggle').on( 'click', function() {
  //   if ( isFlickity ) {
  //     // destroy Flickity
  //     $carousel.flickity('destroy');
  //   } else {
  //     // init new Flickity
  //     $carousel.flickity();
  //   }
  //   isFlickity = !isFlickity;
  // });

  $( window ).resize(function() {
    videoHome();
    heightStaticContent();
    ratioProd();
    heightPagProduct();
    if($carousel && $carouselMobile){
    if ( $(window).width() <= 1075 ) {
      // mobile
      $carousel.flickity();
      $carouselMobile.flickity();
      //$carouselHomeMobile.flickity();
      $carouselHome.flickity({
        wrapAround: true,
        pageDots: true,
        cellAlign: "left",
        contain: true,
        prevNextButtons: false,
      });
      $carouselLoop.flickity({
        wrapAround: true,
        pageDots: false,
        cellAlign: "left",
        contain: true,
        prevNextButtons: false,
      });
      $carouselPageMobile.flickity();
      $carouselShop.flickity();

      if ( $('header > nav.nav').hasClass('open') ) {
        if (jQuery('.box-nav-wrapper').css("left") == "0px") {
          jQuery('.box-nav-wrapper').css("left","0px");
        } else {
          jQuery('.box-nav-wrapper').css("left","-100vw");
        }
      }

    } else {
      if( $('.carousel-vertical').hasClass('flickity-enabled') ) {
        $carousel.flickity('destroy');
      }
      if( $('.js-products-mobile').hasClass('flickity-enabled') ) {
        $carouselMobile.flickity('destroy');
      }
      if( $('.js-carousel-loop').hasClass('flickity-enabled') ) {
        $carouselLoop.flickity('destroy');
      }
      if( $('.js-product-page-mobile').hasClass('flickity-enabled') ) {
        $carouselPageMobile.flickity('destroy');
      }
      if (typeof $carouselPageMobile.data('owl.carousel') != 'undefined') {
        $carouselPageMobile.data('owl.carousel').destroy();
      }
      if( $('.js-carousel-shop-link').hasClass('flickity-enabled') ) {
        $carouselShop.flickity('destroy');
      }
      if ( $('header > nav.nav').hasClass('open') ) {
        if (jQuery('.box-nav-wrapper').css("left") == "0px") {
          jQuery('.box-nav-wrapper').css("left","0px");
        } else {
          jQuery('.box-nav-wrapper').css("left","-339px");
        }
      }

    }
    }
  });

	// btn option
	/*$('.js-btn-option').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    var $val = $(this).data('value');
		var $formId = $(this).parents('.product-size-container').data('option-id');
		$('.form-'+$formId+' option[value="'+$val+'"]').prop('selected', true);
		$('.js-btn-option').removeClass('active');
		$(this).addClass('active');
	});
  */
	
	// home btn shop by category
  /*
	$('.js-btn-single-category').on('click', function(e){
    console.log("click riga 900");
    e.preventDefault();
    e.stopPropagation();
		$('.js-btn-single-category').removeClass('active');
		$(this).addClass('active');
		
		// pulisco tutti i campi
		$('#p-category .carousel-cell a').attr('href','');
		$('#p-category .carousel-cell img').attr('src','/themes/1358/Vietti_BT4/images/img/t.png');
		$('#p-category .carousel-cell .brand').text('');
		$('#p-category .carousel-cell .price').text('');
		
		var $url = $(this).data('url');
		var $urlCat = $(this).data('urlcat');
		var $image = $(this).data('image');
		var $brand = $(this).data('brand');
		var $price = $(this).data('price');
    var $currency_prod = $('.main-carousel.most-popular .product-info .price').data('currency');
    //var $currency_prod = $(this).data('currency');
    //var $currency_prod = $('.js-carousel-loop-popular .carousel-cell.is-selected .product-info .price > span').text();
		
    var $url = $url.split(',');
    for (var a in $url)
    {
      var $variable = $url[a];
			$('#p-category .carousel-cell:eq('+a+') a').attr('href',$variable);
    }
		
		var $image = $image.split(',');
    for (var a in $image)
    {
      var $variable = $image[a];
			if ( $variable == '' ) {
				$('#p-category .carousel-cell:eq('+a+') img').attr('src','/themes/1358/Vietti_BT4/images/img/t.png');
			} else {
				$('#p-category .carousel-cell:eq('+a+') img').attr('src',$variable);
			}
    }
		
		var $brand = $brand.split(',');
    for (var a in $brand)
    {
      var $variable = $brand[a];
			$('#p-category .carousel-cell:eq('+a+') .brand').text($variable);
    }
		
		var $price = $price.split(',');
    for (var a in $price)
    {
      var $variable = $price[a];
      if ( $variable ) {
        console.log("2");
			  $('#p-category .carousel-cell:eq('+a+') .price').html(currency[$currency_prod]+' '+$variable);
      }
    }
		
		$('#p-category a.js-btn-more-products, .js-link-product-all').attr('href',$urlCat);
  });
	*/
	// home btn shop by designer
  /*
	$('.js-btn-single-designer').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
		$('.js-btn-single-designer').removeClass('active');
		$(this).addClass('active');
		
		$('#p-designer .carousel-cell .thumb-product a').attr('href','');
		$('#p-designer .carousel-cell img').attr('src','/themes/1358/Vietti_BT4/images/img/t.png');
		$('#p-designer .carousel-cell .brand').text('');
		$('#p-designer .carousel-cell .price').text('');
		
		var $url = $(this).data('url');
		//var $urlCat = $(this).data('urlcat');
		var $urlCat = $('#p-designer .js-btn-more-products').attr('href');
		var $image = $(this).data('image');
		var $brand = $(this).data('brand');
		var $price = $(this).data('price');
    var $currency_prod = $('.main-carousel.most-popular .product-info .price').data('currency');
    //var $currency_prod = $(this).data('currency');
    //var $currency_prod = $('.js-carousel-loop-popular .carousel-cell.is-selected .product-info .price > span').text();
				
    var $url = $url.split(',');
    for (var a in $url)
    {
      var $variableUrl = $url[a];
			$('#p-designer .carousel-cell:eq('+a+') a').attr('href',$variableUrl);
    }
		
		var $image = $image.split(',');
    for (var a in $image)
    {
      var $variableImage = $image[a];
			if ( $variableImage == '' ) {
				$('#p-designer .carousel-cell:eq('+a+') img').attr('src','/themes/1358/Vietti_BT4/images/img/t.png');
			} else {
				$('#p-designer .carousel-cell:eq('+a+') img').attr('src',$variableImage);
			}
    }
		
		var $brand = $brand.split(',');
    for (var a in $brand)
    {
      var $variable = $brand[a];
			$('#p-designer .carousel-cell:eq('+a+') .brand').text($variable);
    }
		
		var $price = $price.split(',');
    for (var a in $price)
    {
      var $variable = $price[a];
      if ( $variable ) {
        console.log("3");
        $('#p-designer .carousel-cell:eq('+a+') .price').html(currency[$currency_prod]+' '+$variable);
      }
    }
		
		$('#p-designer .js-btn-more-products, .js-link-product-all').attr('href',$urlCatDesigner);
  });
	*/

	// home btn shop by style
	$('.js-btn-single-style').on('click', function(e){
    console.log("click riga 1329"); 
    e.preventDefault();
    e.stopPropagation();
		$('.js-btn-single-style').removeClass('active');
		$(this).addClass('active');
		
		$('#p-style .carousel-cella').attr('href','');
		$('#p-style .carousel-cell img').attr('src','/themes/1358/Vietti_BT4/images/img/t.png');
    $('#p-style .carousel-cell img').attr('alt','');
		$('#p-style .carousel-cell .brand').text('');
		$('#p-style .carousel-cell .price').text('');
		
		var $id = $(this).data('id');
    var $idCatStyle = $(this).data('idstyle');
		var $url = $(this).data('url');
		var $urlCat = $(this).data('urlcat');
		var $image = $(this).data('image');
		var $brand = $(this).data('brand');
		var $price = $(this).data('price');
    var $currency_prod = $('.main-carousel.most-popular .product-info .price').data('currency');
    //var $currency_prod = $(this).data('currency');
    //var $currency_prod = $('.js-carousel-loop-popular .carousel-cell.is-selected .product-info .price > span').text();

		// carico blocco a dx
		var $imgStyle = $(this).data('imagestyle');
		var $titleStyle = $(this).data('title');
		var $textStyle = $(this).data('text');
    var $idstyle = $(this).data('idstyle');
		
		// cancello
		$('.lancio-style figcaption h4').text('');
		$('.lancio-style figcaption p').text('');
		$('.lancio-style img').attr('src','');
		$('.lancio-style').css('background-image', 'url("")');
    $('.lancio-style .btn-default').attr('href', '');

    /*
    $('#p-style .carousel-cell h3').text('');
    $('#p-style .carousel-cell .price').text('');
    $('#p-style .carousel-cell img').attr('src','');
    $('#p-style .carousel-cell img').attr('alt','');
    $('#p-style .carousel-cell a').attr('href', '');
    */
		// scrivo
    if ( $titleStyle != "" ){
      console.log($titleStyle);
      $('.lancio-style figcaption h4').text($titleStyle);
    } 
    if ( $textStyle != "" ){
      $('.lancio-style figcaption p').text($textStyle);
    }
    if ( $imgStyle != "" ){
      $('.lancio-style img').attr('src',$imgStyle);
    }	
		$('.lancio-style').css('background-image', 'url(' + $imgStyle + ')');
    $('.lancio-style .btn-default').attr('href', $idstyle);


    if ( $(window).width() <= 768 ) {
      $carouselMobileHp.data('owl.carousel').destroy();
    }
				
    var $url = $url.split(',');
    for (var a in $url)
    {
      var $variableUrl = $url[a];
			$('#p-style .item:nth-child('+(a+1)+') a, #p-style .owl-item:nth-child('+(a+1)+') a').attr('href',$variableUrl);
    }
		
    
		var $image = $image.split(',');
    var a = 1;
    for (const $variableImage of $image)
    {
      if ( $variableImage.length >= 2 ) {
        $('#p-style .item:nth-child('+a+') img, #p-style .owl-item:nth-child('+a+') img').attr('src',$variableImage);
        $('#p-style .item:nth-child('+a+') img, #p-style .owl-item:nth-child('+a+') img').attr('title','');
        a++;
			}
    }
		
		var $brand = $brand.split(',');
    var b = 1;
    for (const $variable of $brand)
    {
      console.log($variable);
			$('#p-style .item:nth-child('+b+') .brand, #p-style .owl-item:nth-child('+b+') .brand').text($variable);
      b++;
    }
		
		var $price = $price.split(',');
    var c = 1;
    for (const $variable of $price)
    {
      if ( $variable.length >= 2 ) {
        console.log("4");
			  $('#p-style .item:nth-child('+c+') .price, #p-style .owl-item:nth-child('+c+') .price').html(currency[$currency_prod]+' '+$variable);
      }
      c++;
    }
		$('#p-style a.js-btn-more-products').attr('href',$idCatStyle);


    if ( $(window).width() <= 768 ) {
      $carouselMobileHp.owlCarousel({
        loop:true,
        margin:0,
        nav:false,
        items:2,
        dots:false
      });
    };

  });

  // home
  if ( $('.js-products-mobile ').length >= 1 ) {
    $('.price > span').html(currency[$currency_prod]);
  }
	
	
	// designers
	if ( $('.col-designers').length >= 1 ){
		jQuery(".col-designers").each(function( index ) {
			if ( jQuery(this).find('a').length <= 0 ){
				$name = jQuery(this).parents('.alphabetic-column').find('.alphabetic-title').text();
				$name = $name.replace(" ", "");
				console.log($name);
				jQuery(this).parents('.alphabetic-column').hide();
				jQuery('.alphabetic-list ul li.list_'+$name+'').addClass('disabled');
			}
    });
	}
	$('.alphabetic-list ul li.disabled').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
	});
	
	$(window).on('load', function () {
    
    if (isMobile) {
      $carousel.flickity({
        // options
        prevNextButtons: false
      });
    }


		// show .layout-box
		if ( $('.container-loader').length >= 1 ){
			jQuery('.container-loader').addClass('show');
		} else {
      jQuery('.container-loader').addClass('show');
    }
		
		// pagina prodotto
		jQuery('.options-size-product').addClass('show');
		
		// trigger first style
		/*
    if ( $('.marquee-style').length >= 1 ){
			jQuery('.marquee-style span').eq(0).addClass('active').trigger("click");
		}
		*/
    
    function swipeBlockShopBy() {
      
      var $carouselActive = jQuery('.js-carousel-shop-link.carousel-shop-link .is-selected');
			var $section = $carouselActive.find('a').data('section');
      
			$('.layout-box.carousel-shop > div, .layout-shop-link-sub').removeClass('active');
			$('#marquee-'+$section+'').addClass('active');
			
			$('.layout-box.carousel-shop').find('#p-'+$section+'').addClass('active');
			
			if( $section == "category" ){
        console.log('riga 1255');
        var $currency_prod = $('.main-carousel.most-popular .product-info .price').data('currency');
        console.log($currency_prod);
				if (isMobile) {
					$carouselMobile.flickity('destroy');
					$carouselMobile.flickity({
						// options
						wrapAround: true,
						contain: true,
						prevNextButtons: false,
						pageDots: false,
						cellAlign: "left",
						//autoPlay: 3000,
						pauseAutoPlayOnHover: false
					});
				}
				$carouselShopDesk.flickity({
					// options
					wrapAround: true,
					pageDots: false,
					cellAlign: "left",
					contain: true
				});
				$('.section-shop-category .marquee').removeClass('show');
				var $catSelected = $('.js-carousel-shop-link-desk .carousel-cell.is-selected').text().replace(" ", "");
				$('.section-shop-category .marquee-'+$catSelected+'').addClass('show');

				// marquee iniziale
				if ( !$('.section-shop-category .marquee').eq(0).find('.js-marquee-wrapper').length >= 1 ) {
					jQuery('.section-shop-category .marquee').eq(0).marquee({
						duration: 15000,
						//gap in pixels between the tickers
						gap: 0,
						//time in milliseconds before the marquee will start animating
						delayBeforeStart: 0,
						//'left' or 'right'
						direction: 'left',
						//true or false - should the marquee be duplicated to show an effect of continues flow
						duplicated: true
					});
				}

        function clickSubCategoryMobile() {
          // pulisco tutti i campi
					$('#p-category .carousel-cell a').attr('href','');
					$('#p-category .carousel-cell img').attr('src','/themes/1358/Vietti_BT4/images/img/t.png');
					$('#p-category .carousel-cell .brand').text('');
					$('#p-category .carousel-cell .price').text('');

					var $carouselActive = jQuery('#marquee-category .js-carousel-shop-link-desk .is-selected');

					var $url = $carouselActive.data('url');
					var $urlCat = $carouselActive.data('urlcat');
					var $image = $carouselActive.data('image');
					var $brand = $carouselActive.data('brand');
					var $price = $carouselActive.data('price');
          var $currency_prod = $('.main-carousel.most-popular .product-info .price').data('currency');
          //var $currency_prod = $carouselActive.data('currency');
          //var $currency_prod = $('.js-carousel-loop-popular .carousel-cell.is-selected .product-info .price > span').text();

					var $url = $url.split(',');
					for (var a in $url)
					{
						var $variable = $url[a];
						$('#p-category .carousel-cell:eq('+a+') a').attr('href',$variable);
					}

					var $image = $image.split(',');
					for (var a in $image)
					{
						var $variable = $image[a];
						if ( $variable == '' ) {
							$('#p-category .carousel-cell:eq('+a+') img').attr('src','/themes/1358/Vietti_BT4/images/img/t.png');
						} else {
							$('#p-category .carousel-cell:eq('+a+') img').attr('src',$variable);
						}
					}

					var $brand = $brand.split(',');
					for (var a in $brand)
					{
						var $variable = $brand[a];
						$('#p-category .carousel-cell:eq('+a+') .brand').text($variable);
					}

					var $price = $price.split(',');
					for (var a in $price)
					{
						var $variable = $price[a];
            if ( $variable ) {
              console.log("5");
						  $('#p-category .carousel-cell:eq('+a+') .price').html(currency[$currency_prod]+' '+$variable);
            }
					}
        }
				$('.js-carousel-shop-link-desk .flickity-prev-next-button').click(function(e) {
					clickSubCategoryMobile();
				});

				$carouselShopDesk.on( 'change.flickity', function( event, index ) {
					var $catSelected = $('.js-carousel-shop-link-desk .carousel-cell.is-selected').text().replace(" ", "");
					$('.section-shop-category .marquee').removeClass('show');
					$('.section-shop-category .marquee-'+$catSelected+'').addClass('show');
					//console.log( 'Slide changed to ' + index );
					if ( !$('.marquee-'+$catSelected+' .js-marquee-wrapper').length >= 1 ) {
						jQuery('.marquee-'+$catSelected+'').marquee({
							duration: 15000,
							//gap in pixels between the tickers
							gap: 0,
							//time in milliseconds before the marquee will start animating
							delayBeforeStart: 0,
							//'left' or 'right'
							direction: 'left',
							//true or false - should the marquee be duplicated to show an effect of continues flow
							duplicated: true
						});
					}
          clickSubCategoryMobile();
				});
				setTimeout(function(){
					var $urlC = jQuery('#marquee-category .js-carousel-shop-link-desk .is-selected a.link-section').data('urlcat');
					$('#p-category a.js-btn-more-products, .js-link-product-all').attr('href',$urlC);

				}, 1000);

			}
			if( $section == "designer" ){
        console.log('riga 1382');
				if (isMobile) {
					$carouselMobile.flickity('destroy');
					$carouselMobile.flickity({
						// options
						wrapAround: true,
						contain: true,
						prevNextButtons: false,
						pageDots: false,
						cellAlign: "left",
						//autoPlay: 3000,
						pauseAutoPlayOnHover: false
					});
				}
				$('.js-carousel-marquee').flickity({
					// options
					autoPlay: 1500,
					wrapAround: true,
					pageDots: false,
					prevNextButtons: true,
					draggable: false
				});
				$('.js-carousel-marquee .carousel-cell').on('click', function() {
					$('.js-carousel-marquee .carousel-cell').removeClass('active');
					$(this).addClass('active');
					$('.js-carousel-marquee').flickity('playPlayer');
				});
				var $urlC = $(this).data('urlcat');
				//$('#p-designer a.js-btn-more-products').attr('href',$urlC);
				if ( !$('.marquee-designer .js-marquee-wrapper').length >= 1 ) {
					jQuery('.marquee-designer').marquee({
						duration: 15000,
						//gap in pixels between the tickers
						gap: 0,
						//time in milliseconds before the marquee will start animating
						delayBeforeStart: 0,
						//'left' or 'right'
						direction: 'left',
						//true or false - should the marquee be duplicated to show an effect of continues flow
						duplicated: true
					});
				}
			}			
			if ( !$('.marquee-style .js-marquee-wrapper').length >= 1 ) {
				jQuery('.marquee-style').marquee({
					duration: 20000,
					//gap in pixels between the tickers
					gap: 0,
					//time in milliseconds before the marquee will start animating
					delayBeforeStart: 0,
					//'left' or 'right'
					direction: 'left',
					//true or false - should the marquee be duplicated to show an effect of continues flow
					duplicated: true
				});
			}
      
    }

    $carouselShop.on( 'change.flickity', function( event, index ) {
      console.log("2");
      swipeBlockShopBy();
      $('.layout-shop-link .js-carousel-shop-link.carousel-shop-link .carousel-cell').addClass('bg-color-page-dark');
      $('.layout-shop-link .js-carousel-shop-link.carousel-shop-link .carousel-cell.is-selected').removeClass('bg-color-page-dark');
    });
    // home click shop by - quando clicco le frecce
		$('.js-carousel-shop-link.carousel-shop-link .flickity-button').click(function(e) {
			swipeBlockShopBy();
      $('.layout-shop-link .js-carousel-shop-link.carousel-shop-link .carousel-cell').addClass('bg-color-page-dark');
      $('.layout-shop-link .js-carousel-shop-link.carousel-shop-link .carousel-cell.is-selected').removeClass('bg-color-page-dark');
		});
		
 	});
	
	if ( window.location.href.indexOf("donna") > -1 || window.location.href.indexOf("/woman") > -1 || window.location.href.indexOf("/women") > -1 ) {
    $('#btnDonna').addClass('active');
  }
  if ( window.location.href.indexOf("uomo") > -1 || window.location.href.indexOf("/man") > -1 || window.location.href.indexOf("/men") > -1 ) {
    $('#btnUomo').addClass('active');
  }
	
	if ( !$('.marquee-style .js-marquee-wrapper').length >= 1 ) {
		jQuery('.marquee-style').marquee({
			duration: 20000,
			//gap in pixels between the tickers
			gap: 0,
			//time in milliseconds before the marquee will start animating
			delayBeforeStart: 0,
			//'left' or 'right'
			direction: 'left',
			//true or false - should the marquee be duplicated to show an effect of continues flow
			duplicated: true
		});
	}
	if ( !$('.marquee-news .js-marquee-wrapper').length >= 1 ) {
		jQuery('.marquee-news').marquee({
			duration: 15000,
			//gap in pixels between the tickers
			gap: 0,
			//time in milliseconds before the marquee will start animating
			delayBeforeStart: 0,
			//'left' or 'right'
			direction: 'left',
			//true or false - should the marquee be duplicated to show an effect of continues flow
			duplicated: true
		});
	};
	
	if ( !$('.marquee-new-arrivals .js-marquee-wrapper').length >= 1 ) {
		jQuery('.marquee-new-arrivals').marquee({
			duration: 15000,
			//gap in pixels between the tickers
			gap: 0,
			//time in milliseconds before the marquee will start animating
			delayBeforeStart: 0,
			//'left' or 'right'
			direction: 'left',
			//true or false - should the marquee be duplicated to show an effect of continues flow
			duplicated: true
		});
	};
	
	
	if ( $('#map').length >= 1 ) {
			// Create the script tag, set the appropriate attributes
			var script = document.createElement('script');
			script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBb9lTECV_S868YSfrfNKE8-ndAA9C2jMI&callback=initMap';
			script.async = true;

			// Attach your callback function to the `window` object
			window.initMap = function() {
				// JS API is loaded and available
				const map = new google.maps.Map(document.getElementById("map"), {
					center: { lat: 45.752497473582565, lng: 8.559388831970542 },
					zoom: 12,
					streetViewControl: false,
					disableDefaultUI: true,
					mapTypeId: "terrain", //roadmap - satellite - hybrid - terrain
					styles:
					[{"featureType":"water","elementType":"geometry","stylers":[{"color":"#cae0d3"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
				});
				map.setTilt(45);
			};

			// Append the 'script' element to 'head'
			document.head.appendChild(script);
		
	};

  // page catalogue
  if ( $('.container-category-line').length >= 1 ){
    var myTime = setInterval(countDown,100);
    function countDown(){
      if( $('.loading').length <= 0 ){
        $('.container-category-line, .pagination.pagination-catalog').addClass('show');
        clearInterval(myTime);
        var sPageURL = $(location).attr('href')
        //var sPageURL = sPageURL.split('/');
        var count = sPageURL.split("/").length - 1;
        var valueURL = sPageURL.split('/');
        if ( count >= 6 && valueURL[5] == 'designers') {
          $('#filter_char_1951').hide();
        }
      }
    }
  }
  $('.btn-buy:not(.disabled) #button-buy').click(function(){
    let $selectedSize = false;
    $('.product-size-container a.btn').each(function(){
      if( $(this).hasClass('active') ) {
        $selectedSize = true;
      }
    });
    if ( $selectedSize == false ) {
      $('.js-message-selected-size').addClass('show');
    }
  });
  $('.product-size-container a.btn').on('click', function(e) {
    $('.js-message-selected-size').removeClass('show');
  });



  // blog
	$('.js-btn-blog').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    var $post = $(this).data('post');
    var $urlWindowLocation = jQuery(this).attr('href');
    var $u = $urlWindowLocation+'?p='+$post
    window.location.href = $u;
  });


  // register mobile
  $pathNamen = window.location.pathname;
  if ( $pathNamen == "/eshop/register-tab/") {
    //console.log("entro al click");
    $('#register-tab').trigger('click');
  }


  // ship russian
  $('input[type="checkbox"].js-ship-russian').click(function(){
      if($(this).prop("checked") == true){
        //console.log("Checkbox is checked.");
        $('.box-details-checkout .btn-pay').removeClass('disabled');
        $('.msg-error').addClass('hide');
      }
      else if($(this).prop("checked") == false){
        //console.log("Checkbox is unchecked.");
        $('.box-details-checkout .btn-pay').addClass('disabled');
        $('.msg-error').removeClass('hide');
      }
  });

  $('body').on('click', '.btn-pay.disabled', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $('.msg-error').removeClass('hide');
  });

  $('#address_form_modal').on('hidden.bs.modal', function () {
    //alert('close');
    if( $('#address_form_modal form #country_id').val() == 183 ) {
      $('.box-details-checkout .btn-pay').addClass('disabled');
      $('.js-box-ship-russian').addClass('show');
    } else {
      $('.box-details-checkout .btn-pay').removeClass('disabled');
      $('.js-box-ship-russian').removeClass('show');
    }
  })

  // product catalogue
  /*if ( $('.list-product-catalog').length >= 1 ){
    //alert("2");
    var checkAjax = 0;

    
    let timerId = setInterval(function() {
      if (jQuery('.container-category-line .loading').length <= 0) {
        //setTimeout(() => { clearInterval(timerId); alert('stop'); }, 5000);
        clearInterval(timerId);
        //console.log("prodotti caricati");
        if ( $('.category-list.list-product-catalog .product-preview').length <= 0 ) {
          $('.product-empty').addClass('show');
          $('.container-category-line, .pagination.pagination-catalog').addClass('no-product-list');
        }
      } else {
        //console.log("sta caricando i prodotti");
      }
    }, 200);
    


  }*/
  

  $(document).on('click','.adyen-checkout__payment-method__header',function(){
    //  $(this) = your current element that clicked.
    // additional code
    $('.adyen-checkout__payment-method__header').removeClass('active');
    $(this).addClass('active');
  });

  

	
});